import { memoize } from 'lodash-es';

const initializeRUM = async () => {
  const { AwsRum } = await import('aws-rum-web');

  return new AwsRum(
    '3ed99cf6-de69-400b-862e-d69a420fdfa5',
    '1.0.0',
    'us-west-2',
    {
      sessionSampleRate: 1,
      guestRoleArn: 'arn:aws:iam::460223322679:role/beta-us-west-2-GrowThrive-GTCHubbetaRUMIdentityPool-ddwWyoLwL3i4',
      identityPoolId: 'us-west-2:332d4024-75fb-4dc7-9439-b9bbe6f0904b',
      endpoint: `https://dataplane.rum.us-west-2.amazonaws.com`,
      telemetries: [
        'performance',
        'errors',
        ['http', { recordAllRequests: true }],
      ],
      allowCookies: true,
      sessionEventLimit: 0,
      enableXRay: true,
      enableRumClient: true,
      // https://docs.aws.amazon.com/AmazonCloudWatch/latest/monitoring/CloudWatch-RUM-custom-metadata.html
      sessionAttributes: {
        userAgent: navigator.userAgent,
      },
    },
  );
};

// https://github.com/aws-observability/aws-rum-web/blob/main/docs/configuration.md
export const getAwsRumInstance = memoize(initializeRUM);
